import {useParams} from "react-router-dom";
import Card from "../../../../components/Card.jsx";
import React from "react";
import {useModificaSchedulazione} from "./useModificaSchedulazione";
import FormModificaSchedulazione from "./components/FormModificaSchedulazione";

export default function ModificaSchedulazione() {
    const {idSchedulazione} = useParams();

    const {
        getBottoniSx,
        getBottoniDx,
        title,
        schedulazione,
        formikRef,
    } = useModificaSchedulazione({idSchedulazione});

    return (
        <Card
            icon={'fas fa-calendar-alt'}
            title={title}
            getBottoniSx={getBottoniSx}
            getBottoniDx={getBottoniDx}
        >
            <FormModificaSchedulazione
                schedulazione={schedulazione}
                idSchedulazione={idSchedulazione}
                formikRef={formikRef}
            />
        </Card>
    );
}